import type { I18nPrefix } from '../../i18n/prefix';

export const I18N_PAGE = 'features:customers.pages.sales_agents_page' satisfies I18nPrefix;

export const SALES_AGENT_ORDERING_URL = 'https://docs.sparklayer.io/sales-agent-ordering';
